<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <label>Поиск по препарту</label>
          <DrugSearchNew
            ref="searchDrug"
            :onSelect="(d) => selectDrug(d)"
          />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <AdjustInvoices
          ref="AdjustInvoices"
          :drug="selectedDrug"
        />
      </div>
    </div>
  </div>
</template>

<script>

import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import AdjustInvoices from "@/views/stores/components/AdjustInvoices.vue";

export default {
  components: {
    DrugSearchNew,
    AdjustInvoices,
  },
  data() {
    return {
      selectedDrug: null,
    }
  },
  mounted() {
    this.$refs.AdjustInvoices.getInvoices();
  },
  methods: {
    selectDrug(d) {
      this.selectedDrug = d;
      setTimeout(() => {
        this.$refs.AdjustInvoices.getInvoices();
      }, 100);
    },
  }
}

</script>
